import v from 'joi'
import {mapValues} from 'lodash'
import {ITaskEventTracker} from '../shared/db'

type TaskEventTrackerSchemaMapType = v.StrictSchemaMap<Omit<ITaskEventTracker, 'createdAt' | 'updatedAt' | 'count'>>

export const getTaskEventTrackerSchemaMap = (args?: {
  required?: (keyof TaskEventTrackerSchemaMapType)[]
}): TaskEventTrackerSchemaMapType => {
  const schemaMap: TaskEventTrackerSchemaMapType = {
    id: v.string().uuid().optional(),
    taskId: v.string().uuid().optional(),
    inactive: v.bool().optional(),
  }

  if (args?.required?.length) {
    const requiredKeys = args.required
    return mapValues(schemaMap, (v, k) =>
      requiredKeys.includes(k as keyof TaskEventTrackerSchemaMapType) ? v.required() : v,
    ) as TaskEventTrackerSchemaMapType
  }
  return schemaMap
}
